import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Text,
  Center,
} from '@chakra-ui/react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { MyNetworkContext } from 'v4/components/network/context';
import { generateMatrixId } from 'v4/store/actions/global.data.actions';

export const GlobalMatrixPopup = ({
  isOpen,
  onClose,
  title = 'Notice',
  message = 'You’re Offline – Tap to Reconnect',
  confirmText = 'Reconnect',
  onConfirm,
  isLoading = false,
  selectedUserId = null
}) => {
  // const { userProfileInfo } = useSelector((state) => state.userProfile);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="sm">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text textAlign="center">{message}</Text>
        </ModalBody>
        <ModalFooter>
          <Center w="100%">
            <Button
              variant="primary"
              borderRadius="full"
              onClick={() => {
                setLoading(true);
                dispatch(generateMatrixId())
                .then((res) => {
                  localStorage.setItem("matrixData", JSON.stringify(res?.payload?.results  || []));
                  const user = res?.payload?.results?.find(item => item.connection?.requested_for === selectedUserId);
                  const matrixUserId = user?.connection?.room_detail?.users?.find(user => user.id === selectedUserId)?.user_id;
                  onConfirm(matrixUserId);
                }).finally(() =>{
                  setLoading(false);
                  onClose()
                });
              }}
              isLoading={loading}
              w="100%"
            >
              {confirmText}
            </Button>
          </Center>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};